<app-menu></app-menu>
<kor-grid columns="2" spacing="l">
  <app-page-card
    *ngFor="let page of filterService.pages"
    routerLink="/page/{{ page.uid }}"
    (click)="sharedService.logEvent('gallery_page_clicked')"
    [thumbnail]="page.thumbnail"
  >
    <h3>
      <img height="24" width="24" [src]="page.product?.thumbnail" />{{
        page.product.name
      }}
      · {{ page.name }}
    </h3>
    <hr />
  </app-page-card>
</kor-grid>
